import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { TransportInvoiceModel } from 'src/app/models/additional/transport-invoice.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { TransportInvoiceTableModel } from 'src/app/models/tables/additional/transport-invoice-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransportInvoiceService {

  constructor(private _httpClient: HttpClient) { }

  createTransportInvoice(transportInvoiceContract: TransportInvoiceModel): Observable<TransportInvoiceModel> {
    return this._httpClient.post<TransportInvoiceModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoice.CreateTransportInvoice}`,
      transportInvoiceContract
    );
  }

  deleteTransportInvoice(transportInvoiceId: number): Observable<TransportInvoiceModel> {
    return this._httpClient.delete<TransportInvoiceModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoice.DeleteTransportInvoice}/${transportInvoiceId}`
    );
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoice.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllTransportInvoicesWithPagination(
    page: number,
    limit: number,
    columnSort: string | null,
    ascendant: boolean,
    filters: ColumnResponseModel[]
  ): Observable<PagedResponseModel<TransportInvoiceTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<TransportInvoiceTableModel>>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoice.GetAllTransportInvoicesWithPaginationAsync}`,
      filters,
      { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoice.GetColumnsForGeneralConsultationAsync}`
    );
  }

  getFirstTransportInvoiceByKeysAsync(providerId: number): Observable<TransportInvoiceModel> {
    const params = new HttpParams().set('providerId', providerId);
    return this._httpClient.get<TransportInvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoice.GetFirstTransportInvoiceByKeys}`,
      { params: params }
    );
  }

  getLastTransportInvoiceByKeysAsync(providerId: number): Observable<TransportInvoiceModel> {
    const params = new HttpParams().set('providerId', providerId)
    return this._httpClient.get<TransportInvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoice.GetLastTransportInvoiceByKeys}`,
      { params: params }
    );
  }

  getNextTransportInvoiceByKeysAsync(providerId: number, transportInvoiceId: number | null): Observable<TransportInvoiceModel> {
    let params = new HttpParams().set('providerId', providerId)
    if (transportInvoiceId !== null)
      params = params.set('transportInvoiceId', transportInvoiceId.toString());
    return this._httpClient.get<TransportInvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoice.GetNextTransportInvoiceByKeys}`,
      { params: params }
    );
  }

  getPreviusTransportInvoiceByKeysAsync(providerId: number, transportInvoiceId: number | null): Observable<TransportInvoiceModel> {
    let params = new HttpParams().set('providerId', providerId);
    if (transportInvoiceId !== null)
      params = params.set('transportInvoiceId', transportInvoiceId.toString());
    return this._httpClient.get<TransportInvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoice.GetPreviusTransportInvoiceByKeys}`,
      { params: params }
    );
  }

  getTransportInvoiceById(transportInvoiceId: number): Observable<TransportInvoiceModel> {
    return this._httpClient.get<TransportInvoiceModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoice.GetTransportInvoiceById}/${transportInvoiceId}`
    );
  }

  getTransportInvoiceByKeys(providerId: number, documentNumber: string): Observable<TransportInvoiceModel> {
    const params = new HttpParams()
      .set('providerId', providerId.toString())
      .set('documentNumber', documentNumber || '');
    return this._httpClient.get<TransportInvoiceModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoice.GetTransportInvoiceByKeysAsync}`,
      { params }
    );
  }

  setActiveTransportInvoice(transportInvoiceId: number): Observable<TransportInvoiceModel> {
    return this._httpClient.put<TransportInvoiceModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoice.SetActiveTransportInvoice}/${transportInvoiceId}`,
      null
    );
  }

  updateTransportInvoice(transportInvoiceContract: TransportInvoiceModel): Observable<TransportInvoiceModel> {
    return this._httpClient.put<TransportInvoiceModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.transportInvoice.UpdateTransportInvoice}`,
      transportInvoiceContract
    );
  }
}
